/* eslint-disable max-lines-per-function */
/*
 * @Descripttion:
 * @Author:
 * @Date: 2020-09-28 09:45:04
 * @FilePath: \dzCloud\src\projects\tiktok\plugins\sentryConfig.js
 */
import { ajax } from './axios';
// var adObj = null;

const setUpOptions = {
    copyRuleJson: {},
    createTime: '',
    id: '',
    isDefault: '',
    platform: '',
    remark: '',
    shopName: '',
    templateName: '',
    updateTime: '',
    userId: '',
    // 设置商品配置
    copyRule: {
        base: {
            brandId: 596120136,
            supplier: [], // 商品类目
            supplierVal: [], // 选中商品类目
            brandList: [], // 品牌列表
            categoryAutoMap: false,
            isFilter: false,
            BrandId: '', // 品牌ID
            productWeight: '', // 商品重量
            serviceMobile: '', // 客服电话
            filterSet: '1', // 过滤设置
            commit: false, // 发布方式
            payType: 1, // 支付方式
            templateId: 0, // 运费模板id
            enabeldPriceLowerThan: false, // 价格低于多少启用特定运费模板
            priceLowerThan: '', // 价格低于多少
            priceLowerThanTemplateId: '', // 价格低于多少时使用的运费模板
            supply7dayReturn: '0', // 7天无理由退货
            freight: '', // 运费
            supplierAutoMap: '',
            properyNotMatch: 1,
            isUploadMaterial: false,
            startSaleType: false,
        },
        price: {
            priceOperations: {
                // 售卖价
                priceType: 2, // 价格类型  促销价/原价
                priceTypeNum: 1, // 价格系数
                addOrSubtract: 0, // 价格运算方式
                addOrSubtractValue: 0, // 价格运算值
                priceMathRule: 0, // 价格处理
            },
            marketPriceOperations: {
                // 划线价
                priceType: 2, // 价格类型  促销价/原价
                priceTypeNum: 1, // 价格系数
                addOrSubtract: 0, // 价格运算方式
                addOrSubtractValue: 0, // 价格运算值
                priceMathRule: 0, // 价格处理
            },
        },
        inventory: {
            presellType: 0, // 发货模式
            presellEndTime: null, // 预售结束时间
            presellDelay: 0, // 预售结束后几天发货
            stepStockDelay: null, // 阶梯发货时间
            presellConfigLevel: 0, // 时效发货模式
            presellConfigLevelValue: [], // 时效发货时间
            commStock: 1, // 商品库存
            commStockInput: 0, // 商品库存 新库存
            reduceInventoryType: 0, // 减库存类型
        },
        title: {
            deleteKeywords: '', // 删除关键字
            replacekeywords: [
                // 替换关键字
                {
                    originalText: '', // 原文字
                    newText: '', // 新文字
                },
            ],
            prefix: '', // 标题前缀
            suffix: '', // 标题后缀

            isShortProduct: false, // bool类型，是否开启短标题（开启 = true，未开启 = false）
            shortProductType: 1, //int类型，导购短标题设置类型（截取标题前x个字符 = 1，自定义标题 = 2）
            shortProductSubCount: null, //int类型，截取标题前x个字符（shortProductType = 1 时生效）
            shortProductCustom: '', //stirng类型，自定义短标题（shortProductType = 2 时生效）
        },
        text: {
            deleteScopes: [],
            deleteKeywords: '',
            skuDeleteType: 0,
            replaceScopes: [],
            replaceKeywords: [],
            prefixSuffixType: 0,
            prefixSuffixScopes: [],
            prefix: '',
            suffix: '',
            partPrefixSuffix: {
                subjectPrefix: '',
                subjectSuffix: '',
                shortSubjectPrefix: '',
                shortSubjectSuffix: '',
                skuPrefix: '',
                skuSuffix: '',
            },
            subjectSub: 1,
            shortSubjectSub: 1,
            skuSub: 1,
        },
        mainImage: {
            clearMainPic: [], // 删除主图
        },
        detail: {
            source: 0, // 详情来源  0-铺货PC端详情,1-铺货手机端详情
            delDescImgInfo: [], // 删除描述图
            moreThan50Picture: 0, // 图片超50张  0-删除前面的描述图/1-删除后面的描述图
            mainInsertDetailTop: 0, // 主图插入详情顶部
            detailTopInsertImage: [], // 详情头部插入图片
            detailLastInsertImage: [], // 详情头部插入图片
            isPropertyToImage: false, //是否属性转图片，bool类型（是 = true，否 = false）
        },
        property: {
            propertyPadding: '', // 属性填充
            propertyPresets: [
                // 属性预设
                {
                    Name: '',
                    Value: '',
                },
            ],
        },
        sku: {
            isCreateDefaultValue: false,
            overSpecifications: 0, // 规格过多处理
            replacekeywords: [
                // 替换关键字
                {
                    originalText: '', // 原文字
                    newText: '', // 新文字
                },
            ],
            skuCoding: '0', // SKU编码
            enabeldLowCostDrainage: false, // 启用低价引流
            lowCostDrainage: {
                // 低价引流详情
                skuName: '', // sku名称
                priceCoefficient: '', // 价格系数
                addOrSubtract: 0, // 价格运算方式
                addOrSubtractValue: 0, // 价格运算值
                priceMathRule: 0, // 价格处理规则
                inventory: '', // 库存
            },
            copyIamges: false, // 启用铺货SKU图片
        },
        qualification: {
            lualificationLib: [
                // 资质库
                {
                    name: '', // 资质名称
                    images: [], // 资质图片
                },
            ],
        },
        serve: {
            limitPerBuyer: 0, // 单用户累计限购
            maximumPerOrder: 0, // 每次限购
            minimumPerOrder: 0, // 每次至少购买
        },
        returnType: '4', // 退货类型
        productSingerPriceType: 0, // 商品单价类型
        productSingerMarketPriceType: 1, // 商品单价类型
        SKUcodeChecked: false,
        stepStockNum: '', // 阶梯库存 (必须大于0)
        stepStockNumRadio: '1', // 阶梯库存
        replaceKeywordList: [
            {
                formerKeyword: '',
                afterKeyword: '',
            },
        ],
        delDescImgInfo: [
            {
                imgNum: '',
                lastNum: '',
            },
        ],
        completionProperty: false, // 补全商品属性
        propertyContent: '', // 补全内容
        prefix: '', // 前缀
        suffix: '', // 后缀
        qualityImg: '',
        classQuality: [],
        qualityReport: [],
        reduceType: '1',
        skuCopyModel: 0,
        lowerPrice: '', // 如果价格低于
        priceChecked: '', // 价格低于
        packageId: '', // 不包邮模板id
        decimalId: '', // 保留小数
        failChecked: true, // 铺货失败
        sourceRadio: 0, // 详情来源
        imgRadio: 3, // 图片超过50张
        topRadio: 1, // 主图插入详情顶部
        detailTopData: [], // 详情头部插入图片
        detailData: [], // 详情
        setUpOptionsId: '',
    },
};
// if (localStorage.getItem("userInfo")) {
//   var userId = JSON.parse(localStorage.getItem("userInfo")).uid;
//   if (localStorage.getItem(userId + "sentryConfig")) {
//     // do nothing
//   } else {
//     localStorage.setItem(userId + "sentryConfig", JSON.stringify(setUpOptions));
//   }
// } else {
//   // do nothing
// }

export default {
    refresh: (userId) => {
        if (localStorage.getItem(userId + 'sentryConfig')) {
            // do nothing
        } else {
            localStorage.setItem(userId + 'sentryConfig', JSON.stringify(setUpOptions));
        }
    },

    getStorage: (templateId) => {
        return new Promise((resolve) => {
            ajax.post('/cloud/setting/api/CopySetting/Get', {
                platform: '8',
                id: templateId,
            }).then((res) => {
                let json = JSON.parse(res.result.copyRuleJson);
                if (
                    json.base.supplyDayReturn == null ||
                    !json.base.supplyDayReturn ||
                    json.base.supplyReturnType == 0
                ) {
                    res.result.copyRule.base.supplyDayReturn = 0;
                    res.result.copyRule.base.supplyReturnType = 1;
                } else {
                    res.result.copyRule.base.supplyDayReturn = json.base.supplyDayReturn;
                    res.result.copyRule.base.supplyReturnType = json.base.supplyReturnType;
                }
                if (json.sku.skuCodeConfig == null) {
                    res.result.copyRule.sku.skuCodeConfig = {
                        isOpen: false, // 是否开启商品编码设置
                        isPriorityUseSourceCode: true, // 是否优先使用源商品编码
                        skuCoding: 1, //  sku编码  0-不设置，1-使用原商品ID，2-使用来源平台#原商品ID，3-原商品编码(1688)，4-随机编码
                        prefix: '', // 前缀
                        suffix: '', // 后缀
                    };
                } else {
                    res.result.copyRule.sku.skuCodeConfig = json.sku.skuCodeConfig;
                }
                if (res.result.copyRule.sku.skuCodeConfig.skuCoding === 0) {
                    res.result.copyRule.sku.skuCodeConfig.skuCoding = 1;
                }
                if (json.base.isAutoMapSupplyReturn == null) {
                    res.result.copyRule.base.isAutoMapSupplyReturn = false;
                } else {
                    res.result.copyRule.base.isAutoMapSupplyReturn = json.base.isAutoMapSupplyReturn;
                }

                if (json.forbiddenWord == null) {
                    res.result.copyRule.forbiddenWord = {
                        url: '',
                        whitelistUrl: '',
                    };
                } else {
                    res.result.copyRule.forbiddenWord = json.forbiddenWord;
                }
                if (
                    res.result.copyRule.forbiddenWord.whitelistUrl != '' &&
                    res.result.copyRule.forbiddenWord.whitelistUrl != null
                ) {
                    res.result.copyRule.forbiddenWord.isWhite = true;
                } else {
                    res.result.copyRule.forbiddenWord.isWhite = false;
                }
                if (res.result.copyRule.forbiddenWord.url != '' && res.result.copyRule.forbiddenWord.url != null) {
                    res.result.copyRule.forbiddenWord.isUrl = true;
                } else {
                    res.result.copyRule.forbiddenWord.isUrl = false;
                }

                if (json.price.aliPriceType == null) {
                    res.result.copyRule.price.aliPriceType = 0;
                } else {
                    res.result.copyRule.price.aliPriceType = json.price.aliPriceType;
                }
                if (json.price.pddPriceType == null) {
                    res.result.copyRule.price.pddPriceType = 0;
                } else {
                    res.result.copyRule.price.pddPriceType = json.price.pddPriceType;
                }
                if (json.price.isAddFreight == null) {
                    res.result.copyRule.price.isAddFreight = true;
                } else {
                    res.result.copyRule.price.isAddFreight = json.price.isAddFreight;
                }
                if (json.price.addFreight == null) {
                    res.result.copyRule.price.addFreight = 0;
                } else {
                    res.result.copyRule.price.addFreight = json.price.addFreight;
                }
                if (json.price.useAfterCoupon == null) {
                    res.result.copyRule.price.useAfterCoupon = true;
                } else {
                    res.result.copyRule.price.useAfterCoupon = json.price.useAfterCoupon;
                }
                if (json.base.useAutoCargoNumber == null) {
                    res.result.copyRule.base.useAutoCargoNumber = true;
                } else {
                    res.result.copyRule.base.useAutoCargoNumber = json.base.useAutoCargoNumber;
                }
                if (json.base.autoCargoNumberType == null) {
                    res.result.copyRule.base.autoCargoNumberType = 0;
                } else {
                    res.result.copyRule.base.autoCargoNumberType = json.base.autoCargoNumberType;
                }
                if (json.base.customizationCargoNumber == null) {
                    res.result.copyRule.base.customizationCargoNumber = '';
                } else {
                    res.result.copyRule.base.customizationCargoNumber = json.base.customizationCargoNumber;
                }

                if (json.inventory.presellDeliveryType == null || !json.inventory.presellDeliveryType) {
                    res.result.copyRule.inventory.presellDeliveryType = 0;
                } else {
                    res.result.copyRule.inventory.presellDeliveryType = json.inventory.presellDeliveryType;
                }
                if (res.result.copyRule.mainImage.backgroundCut === null) {
                    res.result.copyRule.mainImage.backgroundCut = {
                        isBackgroundCut: false,
                        position: -1,
                    };
                }
                console.log(res.result.copyRule);
                if (
                    res.result.copyRule &&
                    res.result.copyRule.inventory.presellType == 1 &&
                    res.result.copyRule.inventory.presellEndTime == '' &&
                    res.result.copyRule.inventory.presellDelay == ''
                ) {
                    res.result.copyRule.inventory.presellType = 0;
                }
                if (
                    res.result.copyRule &&
                    res.result.copyRule.inventory.presellType == 2 &&
                    res.result.copyRule.inventory.presellType.deliveryDelayDay == '' &&
                    // eslint-disable-next-line eqeqeq
                    res.result.copyRule.inventory.presellDelay == ''
                ) {
                    res.result.copyRule.inventory.presellType = 0;
                }
                if (res.result.copyRule.tikTokFilter.skuPriceFilterSet === null) {
                    res.result.copyRule.tikTokFilter.skuPriceFilterSet = {
                        beginSavePrice: null,
                        endSavePrice: null,
                        isFilterLowPrice: false,
                        isFilterPriceGap: false,
                        filterPriceGapSet: {
                            gapPrice: null,
                            gapType: null,
                            gapMultiple: null,
                        },
                    };
                }
                resolve(res.result);
            });
        });
        /* for (const key in setUpOptions) {
          if (localStorage.getItem(userId + "sentryConfig").indexOf(key) === -1) {
            objSentryConfig[key] = setUpOptions[key];
          }
        } */
        // presellType 发货模式  presellEndTime 预售结束时间  presellDelay 预售结束后几天发货
        // 0现货发货模式  1全款预售发货模式 2阶梯发货模式
        /* if (
              objSentryConfig["presellType"] === 1 &&
              objSentryConfig["presellEndTime"] === "" &&
              objSentryConfig["presellDelay"] === ""
            ) {
              objSentryConfig["presellType"] = 0;
            }
            if (objSentryConfig["presellType"] === 2 && objSentryConfig["deliveryDelayDay"] === "") {
              objSentryConfig["presellType"] = 0;
            }
     */
        // return objSentryConfig
    },
    saveStorage: (data) => {
        return new Promise((resolve) => {
            console.log(data, 'saveStorage');
            ajax.post('/cloud/setting/api/CopySetting/Save', {
                ...data,
                AppKey: '6840999917110199815',
            }).then((res) => {
                resolve(res);
            });
        });
    },

    setStorage: (data) => {
        if (localStorage.getItem('userInfo')) {
            var userId = JSON.parse(localStorage.getItem('userInfo')).uid;
            localStorage.setItem(userId + 'sentryConfig', JSON.stringify(data));
        }
    },
};
